export const getMonthName = (monthNumber) => {
    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    
    return monthNames[monthNumber - 1] || '';
  };

/**
 * Returns the number of business days (Mon–Fri) in a given month/year.
 * Falls back to 21 if result is 0 (safety net).
 */
export const getBusinessDays = (month, year) => {
  const date = new Date(year, month - 1, 1);
  let count = 0;
  while (date.getMonth() === month - 1) {
    const day = date.getDay();
    if (day !== 0 && day !== 6) count++;
    date.setDate(date.getDate() + 1);
  }
  return count || 21;
};